class CartDrawer extends HTMLElement {
    constructor() {
        super();

        this.isCartPage = document.getElementById("main-cart-wrapper");

        this.setInitialItemCountAndEmptyStatus();
        this.setupElements();
        this.setupListeners();
    }

    setInitialItemCountAndEmptyStatus() {
        this.currentItemCount = Array.from(
            this.querySelectorAll('[name="updates[]"]')
        ).reduce((total, quantityInput) => {
            return total + parseInt(quantityInput.value);
        }, 0);

        this.cartIsEmpty = !!!this.currentItemCount;
    }

    setupElements() {
        this.cartDrawerHeader = this.querySelector(".cart-drawer-header h3");
            this.cartAccessibleMessage = this.querySelector(".cart-drawer-title__cart-accessible-message")
        this.lineItemStatusElement = document.getElementById(
            "cart-drawer-line-item-status"
        );
        this.drawerOverlay = document.getElementById("cart-drawer-overlay");
        this.cartDrawerCloseBtn = document.getElementById(
            "CartDrawerDrawerClose"
        );
        this.cartBubble = document.getElementById("cart-icon-bubble");
        this.cartSection = document.getElementById("shopify-section-cart-drawer");
        this.cartSection.style.display = "none"
    }

    setupListeners() {
        this.addEventListener(
            "change",
            debounce((event) => {
                if (event.target.getAttribute("id") == "CartDrawer-note")
                    return;

                this.updateQuantity(
                    event.target.dataset.index,
                    event.target.value,
                    document.activeElement.getAttribute("name")
                );
            }, 100)
        );

        this.cartDrawerCloseBtn.addEventListener("click", () => this.close());
        this.drawerOverlay.addEventListener("click", () => this.close());
        this.cartBubble.addEventListener("click", () => this.open());
        this.setCloseListeners();
    }

    setCloseListeners() {
        document.addEventListener("keyup", (e) => {
            if (e.code == "Escape") this.close();
        });
    }

    open(accessibleMessage) {
        this.cartSection.style.display = "block"

        this.drawerOverlay.classList.replace("closed", "open");
        this.classList.replace("closed", "open");

        this.cartDrawerHeader.focus();

        this.updateCartMessage(accessibleMessage)
    }

    updateCartMessage(accessibleMessage) {
        if (!this.cartAccessibleMessage) return;

        if (!accessibleMessage) {
            this.cartAccessibleMessage.removeAttribute('aria-label')
            this.cartAccessibleMessage.innerHTML = ''
            return;
        }
        this.cartAccessibleMessage.setAttribute('aria-label', accessibleMessage)
        this.cartAccessibleMessage.innerHTML = accessibleMessage
    }

    close() {
        this.classList.replace("open", "closed");
        this.drawerOverlay.classList.replace("open", "closed");

        this.cartSection.style.display = "none"
    }

    getSectionsToRender() {
        let sections = [
            {
                id: "cart-drawer-items-main",
                section: "main-cart-form",
                selector: "#cart-drawer-items .js-contents",
                cartPageReserved: false,
            },
            {
                id: "cart-icon-bubble",
                section: "cart-icon-bubble",
                selector: ".shopify-section",
                cartPageReserved: false,
            },
            {
                id: "cart-drawer-shipping-indicator",
                section: "main-cart-form",
                selector: "#cart-drawer-shipping-indicator",
                cartPageReserved: false,
            },
            {
                id: "cart-drawer-footer-main",
                section: "main-cart-footer",
                selector: ".js-contents",
                cartPageReserved: false,
            },
            {
                id: "main-cart-items",
                section: "main-cart-form",
                selector: ".js-contents",
                cartPageReserved: true,
            },
            {
                id: "main-cart-footer",
                section: "main-cart-footer",
                selector: ".js-contents",
                cartPageReserved: true,
            },
            {
                id: "shopify-section-shipping-indicator",
                section: "shipping-indicator",
                selector: ".js-contents",
                cartPageReserved: true,
            },
        ];

        if (!this.isCartPage) {
            sections = sections.filter((ele) => !ele.cartPageReserved);
        }

        return sections;
    }

    getSectionInnerHTML(html, selector) {
        return new DOMParser()
            .parseFromString(html, "text/html")
            .querySelector(selector).innerHTML;
    }

    // For updating the display on demand, called by other scripts
    updateCartDisplay(parsedState) {
        let sectionsStr = "";

        // Getting sections list and ensuring unique
        let sections = this.getSectionsToRender().map(
            (section) => section.section
        );
        sections = [...new Set(sections)];
        sectionsStr = sections.join(",");

        // Making our call
        fetch(window.Shopify.routes.root + "cart?sections=" + sectionsStr, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        })
            .then((response) => {
                return response.json();
            })
            .then((response) => {
                parsedState.sections = response;
                this.renderContents(parsedState, true);
            })
            .catch((e) => {
                console.log(e);
                throw new Error("Error retreiving cart data for updates.");
            });
    }

    renderContents(parsedState, shouldOpen = true) {
        this.cartIsEmpty = parsedState.item_count === 0;

        this.getSectionsToRender().forEach((section) => {
            this.updateDrawerSectionHTMLWithSectionStr(section, parsedState);
            this.updateMainCartSectionHTMLWithSectionStr(section, parsedState);
        });

        this.updateEmptyCartDrawerState();
    }

    // Used for updating item quantity from within cart drawer
    updateQuantity(line, quantity, name) {
        const body = JSON.stringify({
            line,
            quantity,
            sections: this.getSectionsToRender().map(
                (section) => section.section
            ),
            sections_url: window.location.pathname,
        });

        fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
            .then((response) => {
                return response.text();
            })
            .then((state) => {
                this.postQuantityDisplayUpdate(state, line, name);
            })
            .catch((e) => {
                console.log(e);
            });
    }

    postQuantityDisplayUpdate(state, line, name) {
        const parsedState = JSON.parse(state);

        this.cartIsEmpty = parsedState.item_count === 0;

        this.getSectionsToRender().forEach((section) => {
            this.updateDrawerSectionHTMLWithSectionStr(section, parsedState);

            this.updateMainCartSectionHTMLWithSectionStr(section, parsedState);
        });

        this.updateEmptyCartDrawerState();
        this.reloadCartPageIfEmpty();

        document.dispatchEvent(new Event("postCartAction"));
    }

    updateMainCartSectionHTMLWithSectionStr(section, parsedState) {
        if (section.cartPageReserved && this.isCartPage) {
            const sectionElement = document.querySelector(
                "#main-cart-wrapper #" + section.id
            );
            const childSection = sectionElement.querySelector(section.selector);
            const fallbackSection = document.getElementById(section.id);
            const elementToReplace = childSection || fallbackSection;

            setInnerHTML(
                elementToReplace,
                this.getSectionInnerHTML(
                    parsedState.sections[section.section],
                    section.selector
                )
            );
        }
    }

    updateDrawerSectionHTMLWithSectionStr(section, parsedState) {
        if (!section.cartPageReserved) {
            const sectionElement = document.getElementById(section.id);
            const childSection = sectionElement.querySelector(section.selector);
            const fallbackSection = document.getElementById(section.id);
            const elementToReplace = childSection || fallbackSection;

            setInnerHTML(
                elementToReplace,
                this.getSectionInnerHTML(
                    parsedState.sections[section.section],
                    section.selector
                )
            );
        }
    }

    updateEmptyCartDrawerState() {
        document
            .querySelector("cart-items")
            ?.classList.toggle("is-empty", this.cartIsEmpty);
        document
            .getElementById("main-cart-items")
            ?.classList.toggle("is-empty", this.cartIsEmpty);

        this.classList.toggle("is-empty", this.cartIsEmpty);
    }

    reloadCartPageIfEmpty() {
        let cartItems = document.querySelectorAll(
            "#shopify-section-main-cart-form #main-cart-items .js-contents > .main-cart-item"
        );
        let cartPageItemsContainer = document.querySelectorAll(
            "#shopify-section-main-cart-form #main-cart-items"
        );
        if (!cartItems.length && cartPageItemsContainer.length)
            location.reload();
    }

    updateLiveRegions(line, itemCount) {
        if (this.currentItemCount === itemCount) {
            document
                .getElementById(`CartDrawerLine-item-error-${line}`)
                .querySelector(".cart-item__error-text").innerHTML =
                window.cartStrings.quantityError.replace(
                    "[quantity]",
                    document.getElementById(`CartDrawerQuantity-${line}`).value
                );
        }

        this.currentItemCount = itemCount;
        this.lineItemStatusElement.setAttribute("aria-hidden", true);
        const cartStatus = document.getElementById(
            "cart-drawer-live-region-text"
        );
        cartStatus.setAttribute("aria-hidden", false);

        setTimeout(() => {
            cartStatus.setAttribute("aria-hidden", true);
        }, 1000);
    }
}

customElements.define("cart-drawer", CartDrawer);
